export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[720px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-6">
              <i className="ri-fire-line"></i>
              <span>国产吃瓜视频 · 热门娱乐资讯</span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-foreground-950 leading-tight mb-6">
              吃瓜视频
              <br />
              <span className="text-primary-500">国产热门娱乐内容平台</span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-500 leading-relaxed mb-6">
              聚焦国产吃瓜视频，涵盖国内最新热点事件、综艺片段与影视解说，在线免费观看国产热门内容。
            </p>

            <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-8">
              每日更新海量国产吃瓜视频，从娱乐圈动态到网红八卦，从影视解读到综艺名场面。我们以最快速度汇聚最全的国内热点娱乐资讯，让你一站式掌握所有值得关注的热门内容。无论是顶流明星动态还是素人网红翻车现场，吃瓜视频永远走在娱乐前沿。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-black text-primary-500">10万+</div>
                <div className="text-xs text-foreground-400 mt-1">每日更新内容</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-black text-accent-500">24h</div>
                <div className="text-xs text-foreground-400 mt-1">全天候追踪热点</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-black text-secondary-500">100%</div>
                <div className="text-xs text-foreground-400 mt-1">免费在线观看</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-bold text-sm rounded-lg hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap text-center"
              >
                立即浏览热门内容
              </a>
              <a
                href="#app"
                className="w-full sm:w-auto px-8 py-3.5 bg-background-100 text-foreground-700 font-medium text-sm rounded-lg hover:bg-background-200 transition-all cursor-pointer whitespace-nowrap text-center border border-background-200/70"
              >
                下载App畅享
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20entertainment%20media%20studio%20with%20warm%20coral%20and%20amber%20lighting%20ambience%2C%20modern%20minimalist%20broadcast%20set%20design%20featuring%20curved%20screens%20and%20soft%20illuminated%20panels%2C%20elegant%20editorial%20photography%20with%20cinematic%20color%20grading%2C%20no%20people%2C%20professional%20media%20production%20aesthetic&width=960&height=720&seq=hero-main-01&orientation=landscape"
                alt="吃瓜视频 - 国产热门娱乐内容平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2">
                <span className="w-2.5 h-2.5 rounded-full bg-accent-500 animate-pulse"></span>
                <span className="text-xs text-white/90 font-medium">实时热点追踪中</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}